import React from "react";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import Services from "./IMG/Services1.png";
import Services2 from "./IMG/Services2.png";
import Services3 from "./IMG/Services3.png";
import Services4 from "./IMG/Services4.png";
import "./Services.css";

function PermanentStaffing() {
  return (
    <>
      <NavBar />
      
      {/* Hero Section */}
      <div className="Services-Hero">
        <div className="Services-Hero-Content">
          <h1 className="Services-Hero-Title">Permanent Staffing</h1>
          <p className="Services-Hero-Subtitle">
            Connect with your ideal permanent talent across global markets
          </p>
        </div>
      </div>

      {/* Permanent Staffing Solutions */}
      <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">⭐ PERMANENT HIRING</div>
            <h2 className="Service-Title">Permanent Staffing Solutions</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources is a premier recruitment firm dedicated to connecting talent from around the world with exciting opportunities across national and international job markets. Our extensive reach and expertise allow us to connect skilled professionals with the best job opportunities in regions such as the Middle East, Africa, Canada, UK, Australia, and beyond.
              </p>
              <p className="Service-Paragraph">
                With a focus on professional recruiting principles, we ensure a seamless and effective recruitment process that maximizes the potential of our diverse clientele. Our mission is to help individuals build a safe and secure future by connecting them with international job prospects that offer growth and stability. Join us on an exciting journey towards a brighter future.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon">🌍</div>
                <div className="Feature-Text">Global Network</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">✓</div>
                <div className="Feature-Text">Perfect Fit</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">🚀</div>
                <div className="Feature-Text">Long-term Growth</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">🔒</div>
                <div className="Feature-Text">Stable Career</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services} alt="Permanent Staffing Solutions" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Temporary Staffing */}
      <div className="Service-Section">
        <div className="Service-Container reverse">
          <div className="Service-Content">
            <div className="Service-Badge">⚡ TEMPORARY STAFFING</div>
            <h2 className="Service-Title">Temporary Staffing</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources is a staffing agency that offers temporary staffing solutions. We excel at sourcing and vetting candidates for different positions, taking care of administrative tasks such as contracts and payroll. Our temporary workers seamlessly integrate into client teams and contribute to their overall success.
              </p>
              <p className="Service-Paragraph">
                We provide clients with scalability, cost-effectiveness, access to specialized skills, and the chance to evaluate potential permanent hires. Temporary workers benefit from valuable experience, exposure to diverse industries, networking opportunities, and potential pathways to permanent employment.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon">📈</div>
                <div className="Feature-Text">Scalable Solutions</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">💰</div>
                <div className="Feature-Text">Cost-Effective</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">⏱️</div>
                <div className="Feature-Text">Quick Deployment</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">📋</div>
                <div className="Feature-Text">Full Compliance</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-2"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services2} alt="Temporary Staffing" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Payroll Management */}
      <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">💳 PAYROLL SOLUTIONS</div>
            <h2 className="Service-Title">Payroll Management</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                At Quarec Resources, our payroll management ensures accurate and timely compensation for all our workers. Our dedicated team handles timekeeping, wage calculation, deductions, and payroll processing with meticulous attention to detail and compliance.
              </p>
              <p className="Service-Paragraph">
                We comply with all legal requirements, providing detailed payslips and maintaining strict confidentiality. Our efficient processes prioritize accuracy and transparency. We ensure that our workers receive their wages on time and are fully supported throughout the payroll process.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon">⏰</div>
                <div className="Feature-Text">On-Time Payment</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">✓</div>
                <div className="Feature-Text">Error-Free</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">👮</div>
                <div className="Feature-Text">Legal Compliance</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">🔐</div>
                <div className="Feature-Text">Secure & Confidential</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services3} alt="Payroll Management" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Dedicated IT Resource */}
      <div className="Service-Section">
        <div className="Service-Container reverse">
          <div className="Service-Content">
            <div className="Service-Badge">💻 IT RESOURCES</div>
            <h2 className="Service-Title">Dedicated IT Resources</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources offers dedicated IT resources and teams to support a wide range of projects. Our skilled IT professionals are available to provide specialized expertise and assistance tailored to your specific needs. Whether you require support for software development, system administration, or network infrastructure.
              </p>
              <p className="Service-Paragraph">
                Our dedicated resources are ready to contribute their knowledge and skills. We ensure that our IT teams are equipped with the latest technologies and tools to deliver efficient and effective solutions. Partner with us to access dedicated IT resources that will drive the success of your projects.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon">🛠️</div>
                <div className="Feature-Text">Technical Expertise</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">🔧</div>
                <div className="Feature-Text">24/7 Support</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">📚</div>
                <div className="Feature-Text">Latest Technology</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon">🎓</div>
                <div className="Feature-Text">Certified Team</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-2"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services4} alt="Dedicated IT Resources" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default PermanentStaffing;
